import { render, staticRenderFns } from "./LeaveBalanceView.vue?vue&type=template&id=28c741ea&"
import script from "./LeaveBalanceView.vue?vue&type=script&lang=js&"
export * from "./LeaveBalanceView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalanceView.vue?vue&type=style&index=0&id=28c741ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports